import type { FaireProductEntity } from "../../entity_types/product";

export const p_u5ks92zzna: FaireProductEntity = {
  token: "p_u5ks92zzna",
  type: "product",
  name: "Heath Maple Serving/Chopping Board Wide Pill (Ships from Uk)",
  brandToken: "b_dtfc7uc37e",
  brandName: "Aaron Probyn US",
  imageUrl:
    "https://cdn.faire.com/fastly/b4cd122f0d17b43596c109d8bac71aead4770f1d11502db6f10ebdb833ea682c.jpeg",
  galleryImageUrls: [],
  priceDollars: 23.1,
  description:
    "Please note this product will be shipping from the London, UK warehouse.\n\nThe family of HEATH boards has been designed with communal dining in mind.\n\nMade from Sustainably Sourced American Maple hardwood which is a superior material for chopping boards, holding up to cuts, and resisting moisture.\n\nThe brass handle is both practical and pleasing. The boards are a beautiful backdrop for serving food for any occasion or simply for chopping food in the kitchen.\n\nDimensions: 38x25x2cm\n\nPlease note the handle will add 9 cm to the length of the boards listed.",
  tags: [],
  msrpDollars: 55,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-05-04T23:53:23.722Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
